const schema = {
  scenario: [
    {
      name: 'adCustomizersInAdsEditor',
      value: 'AdCustomizersInAdsEditor',
      setting: {},
      activity: [
        {
          name: 'picker',
          value: 'Picker',
        },
        {
          name: 'feeds',
          value: 'Feeds',
        },
        {
          name: 'countdown',
          value: 'Countdown',
        },
        {
          name: 'keyword',
          value: 'Keyword',
        },
        {
          name: 'iffEditor',
          value: 'IF-function',
        },
        {
          name: 'location',
          value: 'Location',
        },
        {
          name: 'RSAAdCustomizer',
          value: 'RSAAdCustomizer',
        },
      ],
    },
  ],
};

let senario = null;
export function createActivity(instrumentation, activityName) {
  if (!senario) {
    if (!instrumentation.adCustomizersInAdsEditor) {
      instrumentation.addScenario(schema);
    }
    senario = instrumentation.adCustomizersInAdsEditor.create();
  }

  return senario[activityName].create();
}
